function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module typing/utils/injecttypingmutationshandling
 */
import diff from '@ckeditor/ckeditor5-utils/src/diff';
import DomConverter from '@ckeditor/ckeditor5-engine/src/view/domconverter';
import { getSingleTextNodeChange, containerChildrenMutated } from './utils';
/**
 * Handles mutations caused by normal typing.
 *
 * @param {module:core/editor/editor~Editor} editor The editor instance.
 */

export default function injectTypingMutationsHandling(editor) {
  editor.editing.view.document.on('mutations', function (evt, mutations, viewSelection) {
    new MutationHandler(editor).handle(mutations, viewSelection);
  });
}
/**
 * Helper class for translating DOM mutations into model changes.
 *
 * @private
 */

var MutationHandler = /*#__PURE__*/function () {
  /**
   * Creates an instance of the mutation handler.
   *
   * @param {module:core/editor/editor~Editor} editor
   */
  function MutationHandler(editor) {
    _classCallCheck(this, MutationHandler);

    /**
     * Editor instance for which mutations are handled.
     *
     * @readonly
     * @member {module:core/editor/editor~Editor} #editor
     */
    this.editor = editor;
    /**
     * The editing controller.
     *
     * @readonly
     * @member {module:engine/controller/editingcontroller~EditingController} #editing
     */

    this.editing = this.editor.editing;
  }
  /**
   * Handles given mutations.
   *
   * @param {Array.<module:engine/view/observer/mutationobserver~MutatedText|
   * module:engine/view/observer/mutationobserver~MutatedChildren>} mutations
   * @param {module:engine/view/selection~Selection|null} viewSelection
   */


  _createClass(MutationHandler, [{
    key: "handle",
    value: function handle(mutations, viewSelection) {
      if (containerChildrenMutated(mutations)) {
        this._handleContainerChildrenMutations(mutations, viewSelection);
      } else {
        var _iterator = _createForOfIteratorHelper(mutations),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mutation = _step.value;

            // Fortunately it will never be both.
            this._handleTextMutation(mutation, viewSelection);

            this._handleTextNodeInsertion(mutation);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
    /**
     * Handles situations when container's children mutated during input. This can happen when
     * the browser is trying to "fix" DOM in certain situations. For example, when the user starts to type
     * in `<p><a href=""><i>Link{}</i></a></p>`, the browser might change the order of elements
     * to `<p><i><a href="">Link</a>x{}</i></p>`. A similar situation happens when the spell checker
     * replaces a word wrapped with `<strong>` with a word wrapped with a `<b>` element.
     *
     * To handle such situations, the common DOM ancestor of all mutations is converted to the model representation
     * and then compared with the current model to calculate the proper text change.
     *
     * Note: Single text node insertion is handled in {@link #_handleTextNodeInsertion} and text node mutation is handled
     * in {@link #_handleTextMutation}).
     *
     * @private
     * @param {Array.<module:engine/view/observer/mutationobserver~MutatedText|
     * module:engine/view/observer/mutationobserver~MutatedChildren>} mutations
     * @param {module:engine/view/selection~Selection|null} viewSelection
     */

  }, {
    key: "_handleContainerChildrenMutations",
    value: function _handleContainerChildrenMutations(mutations, viewSelection) {
      // Get common ancestor of all mutations.
      var mutationsCommonAncestor = getMutationsContainer(mutations); // Quit if there is no common ancestor.

      if (!mutationsCommonAncestor) {
        return;
      }

      var domConverter = this.editor.editing.view.domConverter; // Get common ancestor in DOM.

      var domMutationCommonAncestor = domConverter.mapViewToDom(mutationsCommonAncestor); // Create fresh DomConverter so it will not use existing mapping and convert current DOM to model.
      // This wouldn't be needed if DomConverter would allow to create fresh view without checking any mappings.

      var freshDomConverter = new DomConverter(this.editor.editing.view.document);
      var modelFromCurrentDom = this.editor.data.toModel(freshDomConverter.domToView(domMutationCommonAncestor)).getChild(0); // Current model.

      var currentModel = this.editor.editing.mapper.toModelElement(mutationsCommonAncestor); // If common ancestor is not mapped, do not do anything. It probably is a parent of another view element.
      // That means that we would need to diff model elements (see `if` below). Better return early instead of
      // trying to get a reasonable model ancestor. It will fell into the `if` below anyway.
      // This situation happens for example for lists. If `<ul>` is a common ancestor, `currentModel` is `undefined`
      // because `<ul>` is not mapped (`<li>`s are).
      // See https://github.com/ckeditor/ckeditor5/issues/718.

      if (!currentModel) {
        return;
      } // Get children from both ancestors.


      var modelFromDomChildren = Array.from(modelFromCurrentDom.getChildren());
      var currentModelChildren = Array.from(currentModel.getChildren()); // Remove the last `<softBreak>` from the end of `modelFromDomChildren` if there is no `<softBreak>` in current model.
      // If the described scenario happened, it means that this is a bogus `<br />` added by a browser.

      var lastDomChild = modelFromDomChildren[modelFromDomChildren.length - 1];
      var lastCurrentChild = currentModelChildren[currentModelChildren.length - 1];
      var isLastDomChildSoftBreak = lastDomChild && lastDomChild.is('element', 'softBreak');
      var isLastCurrentChildSoftBreak = lastCurrentChild && !lastCurrentChild.is('element', 'softBreak');

      if (isLastDomChildSoftBreak && isLastCurrentChildSoftBreak) {
        modelFromDomChildren.pop();
      }

      var schema = this.editor.model.schema; // Skip situations when common ancestor has any container elements.

      if (!isSafeForTextMutation(modelFromDomChildren, schema) || !isSafeForTextMutation(currentModelChildren, schema)) {
        return;
      } // Replace &nbsp; inserted by the browser with normal space. See comment in `_handleTextMutation`.
      // Replace non-texts with any character. This is potentially dangerous but passes in manual tests. The thing is
      // that we need to take care of proper indexes so we cannot simply remove non-text elements from the content.
      // By inserting a character we keep all the real texts on their indexes.


      var newText = modelFromDomChildren.map(function (item) {
        return item.is('$text') ? item.data : '@';
      }).join('').replace(/\u00A0/g, ' ');
      var oldText = currentModelChildren.map(function (item) {
        return item.is('$text') ? item.data : '@';
      }).join('').replace(/\u00A0/g, ' '); // Do nothing if mutations created same text.

      if (oldText === newText) {
        return;
      }

      var diffResult = diff(oldText, newText);

      var _calculateChanges = calculateChanges(diffResult),
          firstChangeAt = _calculateChanges.firstChangeAt,
          insertions = _calculateChanges.insertions,
          deletions = _calculateChanges.deletions; // Try setting new model selection according to passed view selection.


      var modelSelectionRange = null;

      if (viewSelection) {
        modelSelectionRange = this.editing.mapper.toModelRange(viewSelection.getFirstRange());
      }

      var insertText = newText.substr(firstChangeAt, insertions);
      var removeRange = this.editor.model.createRange(this.editor.model.createPositionAt(currentModel, firstChangeAt), this.editor.model.createPositionAt(currentModel, firstChangeAt + deletions));
      this.editor.execute('input', {
        text: insertText,
        range: removeRange,
        resultRange: modelSelectionRange
      });
    }
    /**
     * @private
     */

  }, {
    key: "_handleTextMutation",
    value: function _handleTextMutation(mutation, viewSelection) {
      if (mutation.type != 'text') {
        return;
      } // Replace &nbsp; inserted by the browser with normal space.
      // We want only normal spaces in the model and in the view. Renderer and DOM Converter will be then responsible
      // for rendering consecutive spaces using &nbsp;, but the model and the view has to be clear.
      // Other feature may introduce inserting non-breakable space on specific key stroke (for example shift + space).
      // However then it will be handled outside of mutations, like enter key is.
      // The replacing is here because it has to be done before `diff` and `diffToChanges` functions, as they
      // take `newText` and compare it to (cleaned up) view.
      // It could also be done in mutation observer too, however if any outside plugin would like to
      // introduce additional events for mutations, they would get already cleaned up version (this may be good or not).


      var newText = mutation.newText.replace(/\u00A0/g, ' '); // To have correct `diffResult`, we also compare view node text data with &nbsp; replaced by space.

      var oldText = mutation.oldText.replace(/\u00A0/g, ' '); // Do nothing if mutations created same text.

      if (oldText === newText) {
        return;
      }

      var diffResult = diff(oldText, newText);

      var _calculateChanges2 = calculateChanges(diffResult),
          firstChangeAt = _calculateChanges2.firstChangeAt,
          insertions = _calculateChanges2.insertions,
          deletions = _calculateChanges2.deletions; // Try setting new model selection according to passed view selection.


      var modelSelectionRange = null;

      if (viewSelection) {
        modelSelectionRange = this.editing.mapper.toModelRange(viewSelection.getFirstRange());
      } // Get the position in view and model where the changes will happen.


      var viewPos = this.editing.view.createPositionAt(mutation.node, firstChangeAt);
      var modelPos = this.editing.mapper.toModelPosition(viewPos);
      var removeRange = this.editor.model.createRange(modelPos, modelPos.getShiftedBy(deletions));
      var insertText = newText.substr(firstChangeAt, insertions);
      this.editor.execute('input', {
        text: insertText,
        range: removeRange,
        resultRange: modelSelectionRange
      });
    }
    /**
     * @private
     */

  }, {
    key: "_handleTextNodeInsertion",
    value: function _handleTextNodeInsertion(mutation) {
      if (mutation.type != 'children') {
        return;
      }

      var change = getSingleTextNodeChange(mutation);
      var viewPos = this.editing.view.createPositionAt(mutation.node, change.index);
      var modelPos = this.editing.mapper.toModelPosition(viewPos);
      var insertedText = change.values[0].data;
      this.editor.execute('input', {
        // Replace &nbsp; inserted by the browser with normal space.
        // See comment in `_handleTextMutation`.
        // In this case we don't need to do this before `diff` because we diff whole nodes.
        // Just change &nbsp; in case there are some.
        text: insertedText.replace(/\u00A0/g, ' '),
        range: this.editor.model.createRange(modelPos)
      });
    }
  }]);

  return MutationHandler;
}(); // Returns first common ancestor of all mutations that is either {@link module:engine/view/containerelement~ContainerElement}
// or {@link module:engine/view/rootelement~RootElement}.
//
// @private
// @param {Array.<module:engine/view/observer/mutationobserver~MutatedText|
// module:engine/view/observer/mutationobserver~MutatedChildren>} mutations
// @returns {module:engine/view/containerelement~ContainerElement|engine/view/rootelement~RootElement|undefined}


function getMutationsContainer(mutations) {
  var lca = mutations.map(function (mutation) {
    return mutation.node;
  }).reduce(function (commonAncestor, node) {
    return commonAncestor.getCommonAncestor(node, {
      includeSelf: true
    });
  });

  if (!lca) {
    return;
  } // We need to look for container and root elements only, so check all LCA's
  // ancestors (starting from itself).


  return lca.getAncestors({
    includeSelf: true,
    parentFirst: true
  }).find(function (element) {
    return element.is('containerElement') || element.is('rootElement');
  });
} // Returns true if provided array contains content that won't be problematic during diffing and text mutation handling.
//
// @param {Array.<module:engine/model/node~Node>} children
// @param {module:engine/model/schema~Schema} schema
// @returns {Boolean}


function isSafeForTextMutation(children, schema) {
  return children.every(function (child) {
    return schema.isInline(child);
  });
} // Calculates first change index and number of characters that should be inserted and deleted starting from that index.
//
// @private
// @param diffResult
// @returns {{insertions: number, deletions: number, firstChangeAt: *}}


function calculateChanges(diffResult) {
  // Index where the first change happens. Used to set the position from which nodes will be removed and where will be inserted.
  var firstChangeAt = null; // Index where the last change happens. Used to properly count how many characters have to be removed and inserted.

  var lastChangeAt = null; // Get `firstChangeAt` and `lastChangeAt`.

  for (var i = 0; i < diffResult.length; i++) {
    var change = diffResult[i];

    if (change != 'equal') {
      firstChangeAt = firstChangeAt === null ? i : firstChangeAt;
      lastChangeAt = i;
    }
  } // How many characters, starting from `firstChangeAt`, should be removed.


  var deletions = 0; // How many characters, starting from `firstChangeAt`, should be inserted.

  var insertions = 0;

  for (var _i = firstChangeAt; _i <= lastChangeAt; _i++) {
    // If there is no change (equal) or delete, the character is existing in `oldText`. We count it for removing.
    if (diffResult[_i] != 'insert') {
      deletions++;
    } // If there is no change (equal) or insert, the character is existing in `newText`. We count it for inserting.


    if (diffResult[_i] != 'delete') {
      insertions++;
    }
  }

  return {
    insertions: insertions,
    deletions: deletions,
    firstChangeAt: firstChangeAt
  };
}